import { render, staticRenderFns } from "./Providerlist.vue?vue&type=template&id=0d92a616&scoped=true&"
import script from "./Providerlist.vue?vue&type=script&lang=js&"
export * from "./Providerlist.vue?vue&type=script&lang=js&"
import style0 from "./Providerlist.vue?vue&type=style&index=0&id=0d92a616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d92a616",
  null
  
)

export default component.exports